/**
 * flynt-disable field-lower-snake-case
 * flynt-disable missing-string-validations
 * MAP PLUGIN IS DEPRECATED
 */

export enum MapType {
  /** ROADMAP - Roadmap map type */
  ROADMAP = 'ROADMAP',
  /** SATELITE - Satellite map type */
  SATELITE = 'SATELITE',
  /** HYBRID - Hybrid map type */
  HYBRID = 'HYBRID',
  /** TERRAIN - Terrain map type */
  TERRAIN = 'TERRAIN',
  UNRECOGNIZED = 'UNRECOGNIZED',
}